var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareYt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 12.2857,
    fill: "url(#paint0_linear_1051_20236)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2684 12.2861H14.4714C11.5682 12.2861 9.21484 14.6396 9.21484 17.5427V24.9397C9.21484 27.8428 11.5683 30.1962 14.4714 30.1962H29.2684C32.1716 30.1962 34.5249 27.8428 34.5249 24.9397V17.5427C34.5249 14.6396 32.1715 12.2861 29.2684 12.2861ZM25.7134 21.6011L18.7924 24.9019C18.6079 24.9899 18.3948 24.8556 18.3948 24.6513V17.8432C18.3948 17.6359 18.6136 17.5015 18.7982 17.5953L25.7192 21.1025C25.9253 21.2067 25.9216 21.5019 25.7134 21.6011Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1051_20236",
    x1: 21.5,
    y1: 0,
    x2: 21.5,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F32313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A01F15"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareYt);
export default __webpack_public_path__ + "static/media/share-yt.f7a768556f13c54a706d109154016535.svg";
export { ForwardRef as ReactComponent };